import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Button from "../button/button";
import "./wooden.css";
const Wooden = () => {
  return (
    <Fragment>
      <div className="wooden_body">
        <div className="wooden_main">
          <div className="wooden_text">گجت های چوبی</div>
          <div className="wooden_button">
            <Link to="/catalog">
              <Button
                background="white"
                color="black"
                heigh="50px"
                width="120px"
                radius="23px"
                boxShadow="0px 0px 13px -3px #636e72"
              >
                فروشگاه
              </Button>
            </Link>
          </div>
        </div>
        <div className="wooden_img">
          <img src="https://s18.picofile.com/file/8439985234/wooden.png" />
        </div>
      </div>
    </Fragment>
  );
};

export default Wooden;
